"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.httpClientIntegration = void 0;

var _browserUtils = require("@sentry-internal/browser-utils");

var _core = require("@sentry/core");

var _debugBuild = require("../debug-build.js");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const INTEGRATION_NAME = 'HttpClient';

const _httpClientIntegration = (options = {}) => {
  const _options = _objectSpread({
    failedRequestStatusCodes: [[500, 599]],
    failedRequestTargets: [/.*/]
  }, options);

  return {
    name: INTEGRATION_NAME,

    setup(client) {
      _wrapFetch(client, _options);

      _wrapXHR(client, _options);
    }

  };
};
/**
 * Create events for failed client side HTTP requests.
 */


const httpClientIntegration = exports.httpClientIntegration = (0, _core.defineIntegration)(_httpClientIntegration);
/**
 * Interceptor function for fetch requests
 *
 * @param requestInfo The Fetch API request info
 * @param response The Fetch API response
 * @param requestInit The request init object
 */

function _fetchResponseHandler(options, requestInfo, response, requestInit, error) {
  if (_shouldCaptureResponse(options, response.status, response.url)) {
    const request = _getRequest(requestInfo, requestInit);

    let requestHeaders, responseHeaders, requestCookies, responseCookies;

    if (_shouldSendDefaultPii()) {
      var _parseCookieHeaders2 = _parseCookieHeaders('Cookie', request);

      var _parseCookieHeaders3 = _slicedToArray(_parseCookieHeaders2, 2);

      requestHeaders = _parseCookieHeaders3[0];
      requestCookies = _parseCookieHeaders3[1];

      var _parseCookieHeaders4 = _parseCookieHeaders('Set-Cookie', response);

      var _parseCookieHeaders5 = _slicedToArray(_parseCookieHeaders4, 2);

      responseHeaders = _parseCookieHeaders5[0];
      responseCookies = _parseCookieHeaders5[1];
    }

    const event = _createEvent({
      url: request.url,
      method: request.method,
      status: response.status,
      requestHeaders,
      responseHeaders,
      requestCookies,
      responseCookies,
      error
    });

    (0, _core.captureEvent)(event);
  }
}

function _parseCookieHeaders(cookieHeader, obj) {
  const headers = _extractFetchHeaders(obj.headers);

  let cookies;

  try {
    const cookieString = headers[cookieHeader] || headers[cookieHeader.toLowerCase()] || undefined;

    if (cookieString) {
      cookies = _parseCookieString(cookieString);
    }
  } catch (e2) {// ignore it if parsing fails
  }

  return [headers, cookies];
}
/**
 * Interceptor function for XHR requests
 *
 * @param xhr The XHR request
 * @param method The HTTP method
 * @param headers The HTTP headers
 */


function _xhrResponseHandler(options, xhr, method, headers, error) {
  if (_shouldCaptureResponse(options, xhr.status, xhr.responseURL)) {
    let requestHeaders, responseCookies, responseHeaders;

    if (_shouldSendDefaultPii()) {
      try {
        const cookieString = xhr.getResponseHeader('Set-Cookie') || xhr.getResponseHeader('set-cookie') || undefined;

        if (cookieString) {
          responseCookies = _parseCookieString(cookieString);
        }
      } catch (e3) {// ignore it if parsing fails
      }

      try {
        responseHeaders = _getXHRResponseHeaders(xhr);
      } catch (e4) {// ignore it if parsing fails
      }

      requestHeaders = headers;
    }

    const event = _createEvent({
      url: xhr.responseURL,
      method,
      status: xhr.status,
      requestHeaders,
      // Can't access request cookies from XHR
      responseHeaders,
      responseCookies,
      error
    });

    (0, _core.captureEvent)(event);
  }
}
/**
 * Extracts response size from `Content-Length` header when possible
 *
 * @param headers
 * @returns The response size in bytes or undefined
 */


function _getResponseSizeFromHeaders(headers) {
  if (headers) {
    const contentLength = headers['Content-Length'] || headers['content-length'];

    if (contentLength) {
      return parseInt(contentLength, 10);
    }
  }

  return undefined;
}
/**
 * Creates an object containing cookies from the given cookie string
 *
 * @param cookieString The cookie string to parse
 * @returns The parsed cookies
 */


function _parseCookieString(cookieString) {
  return cookieString.split('; ').reduce((acc, cookie) => {
    const _cookie$split = cookie.split('='),
          _cookie$split2 = _slicedToArray(_cookie$split, 2),
          key = _cookie$split2[0],
          value = _cookie$split2[1];

    if (key && value) {
      acc[key] = value;
    }

    return acc;
  }, {});
}
/**
 * Extracts the headers as an object from the given Fetch API request or response object
 *
 * @param headers The headers to extract
 * @returns The extracted headers as an object
 */


function _extractFetchHeaders(headers) {
  const result = {};
  headers.forEach((value, key) => {
    result[key] = value;
  });
  return result;
}
/**
 * Extracts the response headers as an object from the given XHR object
 *
 * @param xhr The XHR object to extract the response headers from
 * @returns The response headers as an object
 */


function _getXHRResponseHeaders(xhr) {
  const headers = xhr.getAllResponseHeaders();

  if (!headers) {
    return {};
  }

  return headers.split('\r\n').reduce((acc, line) => {
    const _line$split = line.split(': '),
          _line$split2 = _slicedToArray(_line$split, 2),
          key = _line$split2[0],
          value = _line$split2[1];

    if (key && value) {
      acc[key] = value;
    }

    return acc;
  }, {});
}
/**
 * Checks if the given target url is in the given list of targets
 *
 * @param target The target url to check
 * @returns true if the target url is in the given list of targets, false otherwise
 */


function _isInGivenRequestTargets(failedRequestTargets, target) {
  return failedRequestTargets.some(givenRequestTarget => {
    if (typeof givenRequestTarget === 'string') {
      return target.includes(givenRequestTarget);
    }

    return givenRequestTarget.test(target);
  });
}
/**
 * Checks if the given status code is in the given range
 *
 * @param status The status code to check
 * @returns true if the status code is in the given range, false otherwise
 */


function _isInGivenStatusRanges(failedRequestStatusCodes, status) {
  return failedRequestStatusCodes.some(range => {
    if (typeof range === 'number') {
      return range === status;
    }

    return status >= range[0] && status <= range[1];
  });
}
/**
 * Wraps `fetch` function to capture request and response data
 */


function _wrapFetch(client, options) {
  if (!(0, _core.supportsNativeFetch)()) {
    return;
  }

  (0, _core.addFetchInstrumentationHandler)(handlerData => {
    if ((0, _core.getClient)() !== client) {
      return;
    }

    const response = handlerData.response,
          args = handlerData.args,
          error = handlerData.error,
          virtualError = handlerData.virtualError;

    const _args = _slicedToArray(args, 2),
          requestInfo = _args[0],
          requestInit = _args[1];

    if (!response) {
      return;
    }

    _fetchResponseHandler(options, requestInfo, response, requestInit, error || virtualError);
  }, false);
}
/**
 * Wraps XMLHttpRequest to capture request and response data
 */


function _wrapXHR(client, options) {
  if (!('XMLHttpRequest' in _core.GLOBAL_OBJ)) {
    return;
  }

  (0, _browserUtils.addXhrInstrumentationHandler)(handlerData => {
    if ((0, _core.getClient)() !== client) {
      return;
    }

    const error = handlerData.error,
          virtualError = handlerData.virtualError;
    const xhr = handlerData.xhr;
    const sentryXhrData = xhr[_browserUtils.SENTRY_XHR_DATA_KEY];

    if (!sentryXhrData) {
      return;
    }

    const method = sentryXhrData.method,
          headers = sentryXhrData.request_headers;

    try {
      _xhrResponseHandler(options, xhr, method, headers, error || virtualError);
    } catch (e) {
      _debugBuild.DEBUG_BUILD && _core.logger.warn('Error while extracting response event form XHR response', e);
    }
  });
}
/**
 * Checks whether to capture given response as an event
 *
 * @param status response status code
 * @param url response url
 */


function _shouldCaptureResponse(options, status, url) {
  return _isInGivenStatusRanges(options.failedRequestStatusCodes, status) && _isInGivenRequestTargets(options.failedRequestTargets, url) && !(0, _core.isSentryRequestUrl)(url, (0, _core.getClient)());
}
/**
 * Creates a synthetic Sentry event from given response data
 *
 * @param data response data
 * @returns event
 */


function _createEvent(data) {
  const client = (0, _core.getClient)();
  const virtualStackTrace = client && data.error && data.error instanceof Error ? data.error.stack : undefined; // Remove the first frame from the stack as it's the HttpClient call

  const stack = virtualStackTrace && client ? client.getOptions().stackParser(virtualStackTrace, 0, 1) : undefined;
  const message = `HTTP Client Error with status code: ${data.status}`;
  const event = {
    message,
    exception: {
      values: [{
        type: 'Error',
        value: message,
        stacktrace: stack ? {
          frames: stack
        } : undefined
      }]
    },
    request: {
      url: data.url,
      method: data.method,
      headers: data.requestHeaders,
      cookies: data.requestCookies
    },
    contexts: {
      response: {
        status_code: data.status,
        headers: data.responseHeaders,
        cookies: data.responseCookies,
        body_size: _getResponseSizeFromHeaders(data.responseHeaders)
      }
    }
  };
  (0, _core.addExceptionMechanism)(event, {
    type: 'http.client',
    handled: false
  });
  return event;
}

function _getRequest(requestInfo, requestInit) {
  if (!requestInit && requestInfo instanceof Request) {
    return requestInfo;
  } // If both are set, we try to construct a new Request with the given arguments
  // However, if e.g. the original request has a `body`, this will throw an error because it was already accessed
  // In this case, as a fallback, we just use the original request - using both is rather an edge case


  if (requestInfo instanceof Request && requestInfo.bodyUsed) {
    return requestInfo;
  }

  return new Request(requestInfo, requestInit);
}

function _shouldSendDefaultPii() {
  const client = (0, _core.getClient)();
  return client ? Boolean(client.getOptions().sendDefaultPii) : false;
}